import React, { useEffect } from 'react';
import { PerformanceMarks } from '@fiverr-private/obs';
import { FiverrContext } from '@fiverr-private/fiverr_context'; // eslint-disable-line no-unused-vars
import Entry from '/home/circleci/app/src/apps/collaboration/entries/client.js'; // eslint-disable-line import/no-unresolved

/**
 * An HOC that's designed to wrap the consumer's client application, and provide some default "global" behaviour:
 * - Initializes the global FiverrContext property.
 */
const PerseusApp = (props) => {
    useEffect(() => {
        if (typeof performance === 'object') {
            performance.mark(PerformanceMarks.MOUNTED);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <Entry {...props}/>;
};

export default PerseusApp;
